import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Newspaper, FileText, Users, Globe, Plus } from 'lucide-react';
import AdminLayout from '../../components/admin/AdminLayout';
import { useAuth } from '../../context/AuthContext';
import api from '../../utils/api';
import './AdminDashboard.css';

function StatCard({ icon: Icon, label, value, color, to }) {
  return (
    <Link to={to} className="dash-stat" style={{ '--stat-color': color }}>
      <div className="dash-stat-icon"><Icon size={20}/></div>
      <div>
        <p className="dash-stat-value">{value}</p>
        <p className="dash-stat-label">{label}</p>
      </div>
    </Link>
  );
}

export default function AdminDashboard() {
  const { user } = useAuth();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get('/admin/dashboard').then(r => setStats(r.data));
  }, []);

  return (
    <AdminLayout>
      <div className="dash-header">
        <div>
          <h1 className="page-title">Dashboard</h1>
          <p className="dash-sub">Mirë se erdhe, <strong>{user?.name}</strong></p>
        </div>
        <div className="dash-header-actions">
          <Link to="/admin/lajmet/i-ri" className="btn btn-primary btn-sm">
            <Plus size={15}/> Lajm i ri
          </Link>
          <Link to="/admin/publikimet/i-ri" className="btn btn-secondary btn-sm">
            <Plus size={15}/> Publikim i ri
          </Link>
        </div>
      </div>

      {stats ? (
        <>
          <div className="dash-stats">
            <StatCard icon={Newspaper}  label="Lajme gjithsej"   value={stats.news_total}  color="#185FA5" to="/admin/lajmet" />
            <StatCard icon={Globe}      label="Lajme të publikuara" value={stats.news_pub} color="#0A7B55" to="/admin/lajmet?status=published" />
            <StatCard icon={FileText}   label="Publikime"        value={stats.pubs_total}  color="#7C3AED" to="/admin/publikimet" />
            <StatCard icon={Users}      label="Përdorues"        value={stats.users_total} color="#C2620A" to="/admin/perdoruesit" />
          </div>

          <div className="card dash-recent">
            <div className="dash-recent-header">
              <h2 className="dash-section-title">Lajmet e fundit</h2>
              <Link to="/admin/lajmet" className="see-all">Të gjitha →</Link>
            </div>
            <div className="table-wrap">
              <table>
                <thead>
                  <tr>
                    <th>Titulli</th>
                    <th>Statusi</th>
                    <th>Data</th>
                    <th>Veprimet</th>
                  </tr>
                </thead>
                <tbody>
                  {stats.recent_news.map(n => (
                    <tr key={n.id}>
                      <td className="td-title">{n.title}</td>
                      <td>
                        <span className={`badge status-${n.status}`}>
                          {n.status === 'published' ? 'Publikuar' : n.status === 'draft' ? 'Draft' : 'Arkivuar'}
                        </span>
                      </td>
                      <td>{new Date(n.created_at).toLocaleDateString('sq-AL')}</td>
                      <td>
                        <Link to={`/admin/lajmet/${n.id}/ndrysho`} className="btn btn-secondary btn-sm">
                          Ndrysho
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </>
      ) : <div className="spinner" />}

      <div className="dash-links">
        {[
          { to: '/admin/departamentet', label: 'Menaxho Departamentet', icon: '🏥', roles: ['superadmin','admin'] },
          { to: '/admin/services',      label: 'Menaxho Shërbimet',    icon: '🛠️', roles: ['superadmin','admin'] },
          { to: '/admin/udheheqja',     label: 'Menaxho Udhëheqjen',    icon: '👥', roles: ['superadmin','admin'] },
          { to: '/admin/faqet',         label: 'Ndrysho Faqet',         icon: '📄' },
          { to: '/admin/cilesimet',     label: 'Cilësimet e Faqes',     icon: '⚙️', roles: ['superadmin','admin'] },
        ].filter(l => !l.roles || l.roles.includes(user?.role)).map(l => (
          <Link key={l.to} to={l.to} className="card dash-link">
            <span className="dash-link-icon">{l.icon}</span>
            <span>{l.label}</span>
          </Link>
        ))}
      </div>
    </AdminLayout>
  );
}
